import { inject, Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ApplicationStateService } from '../application-state/application-state.service';

@Injectable({ providedIn: 'root' })
export class ApplicationFormControlManagerService {
    private readonly applicationStateService = inject(ApplicationStateService);

    constructor() {}

    public isReadOnly(): boolean {
        const state = this.applicationStateService.getCurrentApplicationState();
        if (!state) {
            throw new Error(
                'ApplicationState has not been initialized. Ensure the application state is set before accessing form controls.',
            );
        }

        return state.isReadOnly;
    }

    enable(
        control: AbstractControl,
        opts?: { onlySelf?: boolean; emitEvent?: boolean },
        extras?: () => void,
    ) {
        if (!this.isReadOnly()) {
            control.enable(opts);
            extras?.();
        }
    }

    disable(
        control: AbstractControl,
        opts?: { onlySelf?: boolean; emitEvent?: boolean },
        extras?: () => void,
    ) {
        control.disable(opts);
        extras?.();
    }
}
